"use strict";
import Blockly from "blockly";


/**
 * @origin basenode.js 来源于 basenode.js 
 * 设置工具箱，添加元素
 * 
 * Adds roles and states.
 * @protected
 * 
 */
 Blockly.tree.BaseNode.prototype.initAccessibility = function () {
  var el = this.getElement()
  if (el) {
    // Set an id for the label
    var label = this.getLabelElement()

    if (label && !label.id) {
      label.id = this.getId() + '.label'
    }

    Blockly.utils.aria.setRole(el, Blockly.utils.aria.Role.TREEITEM)
    Blockly.utils.aria.setState(el, Blockly.utils.aria.State.SELECTED, false)
    Blockly.utils.aria.setState(
      el,
      Blockly.utils.aria.State.LEVEL,
      this.getDepth()
    )
    if (label) {
      Blockly.utils.aria.setState(
        el,
        Blockly.utils.aria.State.LABELLEDBY,
        label.id
      )
    }

    var img = this.getIconElement()
    var ele = this.getElement()
    let text = this.getText()



    if (ele &&text) {
      Blockly.utils.aria.setState(ele, Blockly.utils.aria.State.LABEL, text)
    }

    if (img) {
      Blockly.utils.aria.setRole(img, Blockly.utils.aria.Role.PRESENTATION)
    }

    var ce = this.getChildrenElement()
    if (ce) {
      Blockly.utils.aria.setRole(ce, Blockly.utils.aria.Role.GROUP)

      // In case the children will be created lazily.
      if (ce.hasChildNodes()) {
        // Only set aria-expanded if the node has children (can be expanded).
        Blockly.utils.aria.setState(
          el,
          Blockly.utils.aria.State.EXPANDED,
          false
        )

        // do setsize for each child
        var count = this.getChildCount()
        for (var i = 1; i <= count; i++) {
          var child = /** @type {!Element} */ (this.getChildAt(
            i - 1
          ).getElement())
          Blockly.utils.aria.setState(
            child,
            Blockly.utils.aria.State.SETSIZE,
            count
          )
          Blockly.utils.aria.setState(
            child,
            Blockly.utils.aria.State.POSINSET,
            i
          )
        }
      }
    }
  }
}